// extracted by mini-css-extract-plugin
export default {"formWrapper":"international_formWrapper__sYlW-","rowWrapper":"international_rowWrapper__YWKAc","fxRate":"international_fxRate__RPVbe"};